<template>
    <div>       
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column label="序号" prop="number" min-width="160"></el-table-column>
				<el-table-column label="字段名称" prop="name" min-width="160"></el-table-column>
				<el-table-column label="最近1次编辑时间" prop="modifyTime" min-width="160"></el-table-column>
				<el-table-column label="操作人" prop="modifyUserName" min-width="160"></el-table-column>
				<el-table-column fixed="right" label="操作" width="170">
					<template slot-scope="scope">
						<el-button
						    type="text"
						    size="small"
						    icon="el-icon-s-management"
						    @click="$refs.Update.show(scope.row)"
						    >编辑</el-button>
					</template>					
				</el-table-column>
			</el-table>
		</div>         
		<update ref="Update" @onUpdate="getDataList"></update>
    </div>
</template>

<script>
import Update from './components/update'

export default {
    components: {
        Update
    },
    data(){
       
        return {
            listLoading: false,
            dataList: null,
           
        }
    },
    created(){
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            const data = {...this.paramsInfo};
            this.$request({
                url: "/ticketSeatNumber/list",
                method: "POST",
                data
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                       
                        this.dataList = result;                        
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
       
       
    }
}
</script>

<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>